/**
 * Builds an aria-label for nav links that show a badge (e.g. "NEW").
 * Since badges are visual-only, screen readers need the label to be handled explicitly.
 * Returns undefined when there is no badge so the link keeps its default accessible name.
 */
export function getNavLinkAriaLabel(
  label: string,
  badge?: string
): string | undefined {
  if (!badge) return undefined;
  const badgeText = badge.toUpperCase() === 'NEW' ? 'New item' : badge;
  return `${label}, ${badgeText}`;
}
